const FundStatusEnum = Object.freeze({
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    EVERGREEN: 'EVERGREEN'
});

export default FundStatusEnum;
